import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AgentDetailsLoader from "./agent-details-loader";
import AgentDetailsHeader from "./agent-details-header";
import { mapActions, mapGetters } from "vuex";
import MaterialInput from "@Shared/components/inputs/material-input";
import PhoneInput from "@Shared/components/inputs/phone-input";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Navbar from "@Shared/components/general/nav-bar.vue";
import { LOAD_AGENT, UPDATE_AGENT, LOAD_AGENT_CLIENTS, SORT_AGENT_CLIENTS, UPDATE_AGENT_ACCESS_RIGHTS } from "../store/agent-actions";
import AgentClientsTable from "./agent-clients-table";
import { showToast } from "@Shared/@Utils/constants";
import AgentsLoader from "./agents-loader";
import { GET_AGENT } from "../store/agent-getters";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEqual } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { CURRENT_ACCOUNT_AUTHORIZED } from "@Broker/@Modules/main/store/account/account-getters";
import { GET_CO_BROKERING_OVERRIDES } from "../../settings/store/settings-getters";
export default defineComponent({
  name: "AgentDetails",
  title() {
    return this.$t("sidebar.sections.agents");
  },
  components: {
    AgentDetailsHeader,
    AgentDetailsLoader,
    Navbar,
    MaterialInput,
    PhoneInput,
    AgentClientsTable,
    AgentsLoader
  },
  mixins: [validationMixin],
  validations: {
    agent: {
      givenName: {
        required
      },
      familyName: {
        required
      },
      phoneNumber: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  props: {
    agentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      loadingClients: true,
      currentTab: "details",
      agent: {},
      saving: false,
      savingSucceeded: null,
      sortingClients: false,
      viewOnly: false,
      editCommissions: true,
      submitApplications: true,
      requestBureau: true,
      coBroker: true,
      overrideCobrokering: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AgentStore", [GET_AGENT])), mapGetters("AccountStore", [CURRENT_ACCOUNT_AUTHORIZED])), mapGetters("SettingsStore", [GET_CO_BROKERING_OVERRIDES])), {}, {
    isAccountAuthorized() {
      return this.CURRENT_ACCOUNT_AUTHORIZED;
    },
    tabs() {
      const tabOptions = [{
        label: this.$tc("global.words.detail", 2),
        value: "details"
      }, {
        label: this.$tc("global.doorr.client", 2),
        value: "clients"
      }];
      if (this.isAccountAuthorized) {
        tabOptions.push({
          label: this.$t("access-rights.accessRights"),
          value: "accessRights"
        });
      }
      return tabOptions;
    },
    computedAgent() {
      return this.GET_AGENT(this.agentId);
    },
    isDetailsTabActive() {
      return this.currentTab === "details";
    },
    isClientsTabActive() {
      return this.currentTab === "clients";
    },
    isAccessRightsTabActive() {
      return this.currentTab === "accessRights";
    },
    agentDetailsChanged() {
      var _this$agent$phoneNumb, _this$agent$altPhoneN;
      const agentInfo = _objectSpread(_objectSpread({}, this.computedAgent), {}, {
        givenName: this.agent.givenName,
        familyName: this.agent.familyName,
        email: this.agent.email,
        phoneNumber: (_this$agent$phoneNumb = this.agent.phoneNumber) != null ? _this$agent$phoneNumb : this.computedAgent.phoneNumber,
        altPhoneNumber: (_this$agent$altPhoneN = this.agent.altPhoneNumber) != null ? _this$agent$altPhoneN : this.computedAgent.altPhoneNumber
      });
      return !isEqual(agentInfo, this.computedAgent);
    },
    isAccessRightsChanged() {
      var _this$computedAgent;
      const accessRights = {
        viewOnly: this.viewOnly,
        editCommissions: this.editCommissions,
        requestCreditBureaus: this.requestBureau,
        submitApplications: this.submitApplications,
        coBroker: this.coBroker,
        overrideCobrokering: this.overrideCobrokering
      };
      return !isEqual(accessRights, (_this$computedAgent = this.computedAgent) == null ? void 0 : _this$computedAgent.accessRights);
    },
    canSave() {
      if (this.isDetailsTabActive) {
        return !this.$v.$invalid && this.agentDetailsChanged && this.isDetailsTabActive;
      }
      return this.isAccessRightsTabActive && this.isAccessRightsChanged;
    }
  }),
  watch: {
    agentId() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
    this.amplitudeLogCurrentTab("details");
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AgentStore", [LOAD_AGENT, UPDATE_AGENT, LOAD_AGENT_CLIENTS, SORT_AGENT_CLIENTS, UPDATE_AGENT_ACCESS_RIGHTS])), {}, {
    async loadData() {
      this.loading = true;
      await this.LOAD_AGENT(this.agentId);
      this.agent = _objectSpread(_objectSpread({}, this.computedAgent), {}, {
        username: this.agentId
      });
      this.loading = false;
    },
    async loadClients() {
      this.loadingClients = true;
      await this.LOAD_AGENT_CLIENTS(this.agentId);
      this.loadingClients = false;
    },
    loadAccessRights() {
      var _this$computedAgent2, _this$computedAgent2$, _this$computedAgent3, _this$computedAgent3$, _this$computedAgent4, _this$computedAgent4$, _this$computedAgent5, _this$computedAgent5$, _this$computedAgent6, _this$computedAgent6$, _this$computedAgent7, _this$computedAgent7$;
      this.viewOnly = (_this$computedAgent2 = this.computedAgent) == null ? void 0 : (_this$computedAgent2$ = _this$computedAgent2.accessRights) == null ? void 0 : _this$computedAgent2$.viewOnly;
      this.submitApplications = (_this$computedAgent3 = this.computedAgent) == null ? void 0 : (_this$computedAgent3$ = _this$computedAgent3.accessRights) == null ? void 0 : _this$computedAgent3$.submitApplications;
      this.editCommissions = (_this$computedAgent4 = this.computedAgent) == null ? void 0 : (_this$computedAgent4$ = _this$computedAgent4.accessRights) == null ? void 0 : _this$computedAgent4$.editCommissions;
      this.requestBureau = (_this$computedAgent5 = this.computedAgent) == null ? void 0 : (_this$computedAgent5$ = _this$computedAgent5.accessRights) == null ? void 0 : _this$computedAgent5$.requestCreditBureaus;
      this.coBroker = (_this$computedAgent6 = this.computedAgent) == null ? void 0 : (_this$computedAgent6$ = _this$computedAgent6.accessRights) == null ? void 0 : _this$computedAgent6$.coBroker;
      this.overrideCobrokering = (_this$computedAgent7 = this.computedAgent) == null ? void 0 : (_this$computedAgent7$ = _this$computedAgent7.accessRights) == null ? void 0 : _this$computedAgent7$.overrideCobrokering;
    },
    handleTabChange(tab) {
      this.currentTab = tab;
      if (this.isClientsTabActive) this.loadClients();
      if (this.isAccessRightsTabActive) this.loadAccessRights();
      this.amplitudeLogCurrentTab(tab);
    },
    async handleSubmit() {
      this.saving = true;
      try {
        if (this.isDetailsTabActive) {
          await this.UPDATE_AGENT({
            details: {
              givenName: this.agent.givenName,
              familyName: this.agent.familyName,
              email: this.agent.email,
              phoneNumber: this.agent.phoneNumber,
              altPhoneNumber: this.agent.altPhoneNumber
            },
            agentUsername: this.agentId
          });
        }
        if (this.isAccessRightsTabActive) {
          await this.UPDATE_AGENT_ACCESS_RIGHTS({
            agentUsername: this.agentId,
            accessRights: {
              viewOnly: this.viewOnly,
              submitApplications: this.submitApplications,
              editCommissions: this.editCommissions,
              requestCreditBureaus: this.requestBureau,
              coBroker: this.coBroker
            }
          });
        }
        this.savingSucceeded = true;
        showToast("success", "agentUpdated");
        Amplitude.logEvent(`Agents - ${this.currentTab} updated`, {
          page: "agents",
          subpage: `agent-${this.currentTab}`,
          data: {
            agentUsername: this.agentId
          }
        });
      } catch (e) {
        this.savingSucceeded = false;
      }
      this.saving = false;
    },
    async handleSort({
      orderBy,
      orderType
    }) {
      this.sortingClients = true;
      await this.SORT_AGENT_CLIENTS({
        agentUsername: this.agentId,
        orderBy,
        orderType
      });
      this.sortingClients = false;
    },
    amplitudeLogCurrentTab(tab) {
      Amplitude.logEvent(`Agents - ${tab} visited`, {
        page: "agents",
        subpage: `agent-${tab}`,
        data: {
          agentUsername: this.agentId
        }
      });
    },
    changeRightsToNo() {
      if (this.viewOnly) {
        this.requestBureau = this.editCommissions = this.submitApplications = this.coBroker = false;
      }
    }
  })
});